import {del, get, post, put} from "../../helpers/utils/http-client";
import {APPS_ENDPOINT} from "../../consts/api-endpoints";
import {redactPiiTokens} from "../../helpers/utils/text-util";

export const SESSION_PAGE_SIZE = 25;

// Page sizes offered in the session list pager.
export const SESSION_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const EMPTY_PAGE = { data: [], pagination: {} };

/**
 * List an app's sessions, most recently active first.
 *
 * The backend only honours `requestPage` when `pageSize` is sent alongside it,
 * so both always go together - the same contract the tracing API uses.
 */
export async function getSession(appId, requestPage, pageSize = SESSION_PAGE_SIZE) {
    try {
        const params = { pageSize };
        if (requestPage) {
            params.requestPage = requestPage;
        }

        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/sessions`, params);
        if (status !== 200) {
            return EMPTY_PAGE;
        }
        return redactPiiTokens(response);
    } catch (err) {
        console.debug('sessionList failed cause', err.message, err.code);
        return EMPTY_PAGE;
    }
}

/**
 * Messages of a session. Personal data comes back masked; `reveal` asks for the stored
 * values, which the API only grants to a security admin.
 */
export async function getMessages(appId, sessionId, reveal = false) {
    try {
        const { response, status } = await get(
            `${APPS_ENDPOINT}/${appId}/sessions/${sessionId}/messages`,
            reveal ? { reveal: 'true' } : undefined);
        if (status !== 200) {
            return {
                data: []
            };
        }
        return redactPiiTokens(response);
    } catch (err) {
        console.debug('sessionList failed cause', err.message, err.code);
        return {
            data: []
        };
    }
}

export async function setHandleBy(appId, sessionId, handleBy) {
    try {
        const { response, status } = await post(`${APPS_ENDPOINT}/${appId}/sessions/${sessionId}/handle-by`,
            {handleBy});
        if (status !== 200) {
            return {
                data: {}
            };
        }
        return response;
    } catch (err) {
        console.debug('sessionList failed cause', err.message, err.code);
        return {
            data: {}
        };
    }
}
